import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Requestactivitylog } from './requestactivitylog';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RequestactivitylogService {
  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }


  Get(): Observable<Requestactivitylog[]> {
    return this.httpClient.get<Requestactivitylog[]>(this.baseUrl + 'api/RequestActivityLogApi/GetAll')
  }

  GetById(requestdetailid:any): Observable<Requestactivitylog[]> {
    return this.httpClient.get<Requestactivitylog[]>(this.baseUrl + 'api/RequestActivityLogApi/GetById/'+ requestdetailid);
  }
}
